<div class="forbidden_header">
<project-details-default-header [project]="projectHeader"></project-details-default-header>
<project-details-forbidden-features [project]="projectHeader"></project-details-forbidden-features>
</div>
